import {
  LayoutDashboard,
  Users,
  Building2,
  Rocket,
  Settings,
  Search,
  Target,
  Zap,
  Handshake,
  CheckSquare,
  ShieldAlert,
  Wallet,
  UserCheck,
  Briefcase,
  Heart,
  HeartHandshake,
  Globe,
  TrendingUp,
  UserCog,
  Gift,
} from 'lucide-react'
import { CONECTA_MODULES, type ConectaModuleId } from '@/config/conectaPlatform'
import { isRocketInstance } from '@/config/instanceProfile'
import type { NavSectionKey } from './navIconStyles'
import type { NavLinkItem } from './sidebarNavItem'

export type NavSection = {
  label: string
  moduleId: ConectaModuleId
  themeKey: NavSectionKey
  items: NavLinkItem[]
  adminOnly?: boolean
}

export const CONECTA_NAV_SECTIONS: NavSection[] = [
  {
    label: CONECTA_MODULES.comercial.navLabel,
    moduleId: 'comercial',
    themeKey: 'commercial',
    items: [
      {
        icon: LayoutDashboard,
        label: 'Dashboard',
        to: '/dashboard',
        roles: isRocketInstance ? ['admin', 'closer', 'manager'] : ['admin', 'closer'],
      },
      { icon: Search, label: 'Leads & BDR', to: '/bdr-panel', roles: ['admin', 'bdr', 'closer'] },
      {
        icon: Target,
        label: 'Negociações',
        to: '/deals',
        roles: isRocketInstance ? ['admin', 'closer', 'bdr', 'manager'] : ['admin', 'closer', 'bdr'],
      },
      { icon: CheckSquare, label: 'Tarefas', to: '/tarefas', roles: ['admin', 'manager', 'closer', 'bdr', 'cs'] },
      { icon: Rocket, label: 'Rocket Search', to: '/rocket-search', roles: ['admin', 'bdr', 'closer'] },
      {
        icon: Zap,
        label: 'Minha Carteira',
        to: '/closer-leads',
        roles: isRocketInstance ? ['admin', 'closer', 'bdr', 'manager'] : ['admin', 'closer', 'bdr'],
      },
      {
        icon: Building2,
        label: 'Empresas',
        to: '/empresas',
        roles: isRocketInstance ? ['admin', 'closer', 'bdr', 'manager'] : ['admin', 'closer', 'bdr'],
      },
      {
        icon: Users,
        label: 'Contatos',
        to: '/empresas?view=contatos',
        roles: isRocketInstance ? ['admin', 'closer', 'bdr', 'manager'] : ['admin', 'closer', 'bdr'],
      },
    ],
  },
  {
    label: 'PARCEIROS',
    moduleId: 'comercial',
    themeKey: 'partners',
    items: [
      {
        icon: Handshake,
        label: 'Parceiros',
        to: '/partners',
        roles: isRocketInstance ? ['admin', 'closer', 'manager'] : ['admin', 'closer'],
      },
      {
        icon: UserCheck,
        label: 'Leads de Parceiros',
        to: '/indicacoes',
        roles: isRocketInstance ? ['admin', 'closer', 'manager'] : ['admin', 'closer'],
      },
      {
        icon: Gift,
        label: 'Promoções',
        to: '/partners/promocoes',
        roles: isRocketInstance ? ['admin', 'closer', 'manager'] : ['admin', 'closer'],
      },
    ],
  },
  {
    label: CONECTA_MODULES.cs.navLabel,
    moduleId: 'cs',
    themeKey: 'customerSuccess',
    items: [
      { icon: TrendingUp, label: 'Painel', to: '/cs', roles: ['admin', 'manager', 'cs'] },
      { icon: HeartHandshake, label: 'Carteira', to: '/cs/carteira', roles: ['admin', 'manager', 'cs'] },
      { icon: Heart, label: 'Retenção', to: '/cs/retencao', roles: ['admin', 'manager', 'cs'] },
    ],
  },
  {
    label: CONECTA_MODULES.portal_pj.navLabel,
    moduleId: 'portal_pj',
    themeKey: 'management',
    items: [{ icon: Globe, label: 'Portal', to: '/portal', roles: ['admin', 'closer', 'bdr', 'financeiro', 'manager'] }],
  },
  {
    label: CONECTA_MODULES.operacoes.navLabel,
    moduleId: 'operacoes',
    themeKey: 'management',
    items: [{ icon: UserCog, label: 'Portal Gestores', to: '/gestores', roles: ['admin', 'manager'] }],
  },
  {
    label: CONECTA_MODULES.financeiro.navLabel,
    moduleId: 'financeiro',
    themeKey: 'financeiro',
    items: [
      { icon: Wallet, label: 'Módulo Financeiro', to: '/financeiro', roles: ['admin', 'financeiro'] },
      { icon: UserCheck, label: 'Clientes', to: '/clientes', roles: ['admin', 'financeiro', 'closer'] },
      { icon: Briefcase, label: 'Funcionários PJ', to: '/pj-agrada', roles: ['admin', 'financeiro'] },
    ],
  },
  {
    label: CONECTA_MODULES.admin.navLabel,
    moduleId: 'admin',
    themeKey: 'system',
    adminOnly: true,
    items: [
      { icon: Settings, label: 'Configuração', to: '/configuracao', roles: isRocketInstance ? ['admin', 'manager'] : ['admin'] },
      { icon: ShieldAlert, label: 'Anti-Bot', to: '/security/bots', roles: ['admin'] },
    ],
  },
]
